import { render, staticRenderFns } from "./SkeletonTixstockFeaturedCategories.vue?vue&type=template&id=1b66fae1&scoped=true"
import script from "./SkeletonTixstockFeaturedCategories.vue?vue&type=script&lang=js"
export * from "./SkeletonTixstockFeaturedCategories.vue?vue&type=script&lang=js"
import style0 from "./SkeletonTixstockFeaturedCategories.vue?vue&type=style&index=0&id=1b66fae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66fae1",
  null
  
)

export default component.exports